import '../plugins/pdfPlugin';

export default function initEbook() {
	$(function () {
        $('[data-pdf-url]').each(function() {
            $(this).PDFDisplay();
        });
    });
}
